// file name :- cart-api.js
// changes :- change in changeItem: function add this line key = key.includes(":") ? key.split(":")[0] : key;

// file Name :- cart-item.liquid 
// changes :- change id={{ item.key }} to id={{ item.id }} in reclass="cart__remove" btn     
//  <a href="{{ routes.cart_change_url }}?id={{ item.id }}&amp;quantity=0" class="text-link"> {{ 'actions.remove' | t }}</a>


ACDiscountApp.CartPage.Show_CalculateTier = function () {
    let TierProducts = [];
    var postDataDiscountArrayObject = [];
    var discountMsg = "TIERED_DISCOUNT";
    let runAttributeCode = true;
    let bulkBuyOnCollection = {};
    let collectionBundleItemsRemaining = 0;
    let setCheckOutBtnDisable = false;
    let qtyDiscountedVariantIds = [];
    let nonDiscountedItems = [];
    let orderDiscount =[];
    let tempSubtotal =0;


    function createDiscountObject(msg, variantId, value) {
        return { message: msg, targets: [{ productVariant: { id: variantId } }], value: value };
    }
    function createPercentageDiscountObject(msg, percentage, variantId) {
        return createDiscountObject(msg, variantId, { percentage: { value: percentage } });
    }
    function createAmountOffDiscountObject(msg, variantId, currencyRate, amount, qtys) {
        const totalDiscountedAmount = (amount * currencyRate * qtys).toFixed(2);
        return createDiscountObject(msg, variantId, { fixedAmount: { amount: totalDiscountedAmount } });
    }
    function createDiscountedPriceDiscountObject(msg, variantId, currencyRate, amount, qtys, price) {
        const discountAmount = (amount * currencyRate).toFixed(2);
        if (price > discountAmount) {
            const discountValue = (price - discountAmount).toFixed(2);
            const totalDiscountedAmount = (discountValue * qtys).toFixed(2);
            return createDiscountObject(msg, variantId, { fixedAmount: { amount: totalDiscountedAmount } });
        }
        return null;
        }

function createOrderDiscount(message, excludedVariantIds = [], type, value) {
  if (!value || value <= 0) return { operations: [] };

  return {
    message,
    targets: [
      {
        orderSubtotal: { excludedVariantIds }
      }
    ],
    value:
      type === "fixed"
        ? { fixedAmount: { amount: String(value) } }
        : { percentage: { value: String(value) } }
  };
}

        
async function setDateTimeInCart() {

  try {

    const chunkSize = 70;
    const maxAttributes = 5;

    let attributes = {};

    let chunks = [];

    if (runAttributeCode && postDataDiscountArrayObject.length > 0) {

      for (let i = 0; i < postDataDiscountArrayObject.length; i += chunkSize) {
        chunks.push(postDataDiscountArrayObject.slice(i, i + chunkSize));
      }

    }

    for (let i = 0; i < maxAttributes; i++) {

      let key = i === 0
        ? "Discountly_dateTime"
        : `Discountly_dateTime_${i}`;

      if (chunks[i]) {

        attributes[key] = JSON.stringify(chunks[i]);
      } else {
        attributes[key] = "";
      }
        if (i == 0) {
          attributes['Discountly_BogoDiscount'] = `${globalFields.Storetime()},${Shopify.shop}`
          
        }
    }
// attributes["DiscountlySubTotal"] =  JSON.stringify(orderDiscount);
    // console.log("Sending attributes →", attributes);

    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes: attributes
      })
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();

    if (
      globalFieldsCartPage_AC.cartObj?.original_total_price !==
      data?.original_total_price
    ) {
      globalFieldsCartPage_AC.cartObj = data;
      TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
    }

    jQuery(".loading-overlay").addClass("hidden");

  } catch (error) {

    console.error("Cart update failed:", error);

  } finally {
    $('#data-discounts-main .cart__discounts').hide()
    setCheckOutBtnDisable = false
    makeEnableDisablebtn(false);

  }

}


function getValidDiscountAttribute(orderDiscount) {
  if (
    !orderDiscount ||
    !orderDiscount.discounts ||
    orderDiscount.discounts.length === 0
  ) {
    return "";
  }

  return JSON.stringify(orderDiscount);
}

    var cartPageItemPrice = ".main-content .cart__page .cart__item .cart__item-price-col";
    var cartPageLineItemPrice = ".nouse";
    var drawerItemPrice = ".drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices nouse";
    var drawerLineItemPrice = ".cart-drawer-form .cart-items .cart-item-price-wrapper nouse";
    var cartPageCartTotalPrice = ".cart__page-col .cart__item-sub.cart__item--subtotal";
    var drawerCartTotalPrice = ".cart-drawer-form .ajax-cart--total-price nouse";
    var savingMessageCartPage = ".drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices nouse";
    var checkoutButtonCartPage = '.cart__page button[name="checkout"]';
    var checkoutButtonDrawerPage =".drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices nouse";

       var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index) {
        if (isUpdate) {
          
            var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            
            if (condition1) {
              let tempdiscountMsg = item?.discounts?.[0]?.title || '';
              if (tempdiscountMsg) {
                updatedItemPrice = item.discounted_price/100;
                updatedLinePrice = item.final_line_price/100;
                 condition1 = updatedItemPrice == originalItemPrice;
                 isNotInRange = false;
                 discountMsg = tempdiscountMsg 
                tempSubtotal += originalLinePrice - updatedLinePrice
              }
            }
            updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);
              if (isNotInRange || condition1) {
                jQuery(cartPageItemPrice).eq(index).html(`<span class="cart__price ac-"><div><span class="money" data-currency-eur="${updatedItemPrice}" data-currency="globalFields.currencySymbol">${globalFields.formatMoney(updatedItemPrice, globalFields.amount) }</span></div></span>`);
               // jQuery(cartPageLineItemPrice).eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
            }
            else {
                
                let discountPrice = originalLinePrice - updatedLinePrice
                discountPrice = globalFields.ConvertToFixedDecimalString(discountPrice)
                originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
               
                 jQuery(cartPageItemPrice).eq(index).html(` <span class="visually-hiddenn ac-">Regular price</span><small class="cart__price cart__price--strikethrough"><div><span class="money" data-currency-eur="${originalItemPrice}" data-currency="EUR">${globalFields.formatMoney(originalItemPrice, globalFields.amount) }</span></div></small><span class="visually hiddenn">Sale price</span><span class="cart__price cart__discount"><span aria-hidden="true">${globalFields.formatMoney(updatedItemPrice, globalFields.amount) }</span><span class="visually-hidden">${globalFields.formatMoney(updatedItemPrice, globalFields.amount) }</span></span><small class="cart__discount">${discountMsg} (-${globalFields.formatMoney(discountPrice, globalFields.amount) })</small>`);
               // jQuery(cartPageLineItemPrice).eq(index).html('<div ><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice , globalFields.amount) + '</span></div>');
         
                
            }
        }
    }

    var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
        if (isUpdate) {
          if(tempSubtotal >0){
            
             updatedTotalPrice = updatedTotalPrice - tempSubtotal
          }
            updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
            if (originalTotalPrice != updatedTotalPrice) {
                // if(valuecheck.includes(true)){
                jQuery(cartPageCartTotalPrice).html(`<div>Subtotal</div><div data-subtotal=""><span aria-hidden="true">${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)}</span><span class="visually-hidden">${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)}</span></div>`);
               // jQuery('.cart-order__recap .h-stack.gap-4.justify-between .h5:last').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
                // }else{
                //  jQuery('.cart-order__recap .h-stack.gap-4.justify-between .text-subdued:last').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
                // jQuery('.cart-order__recap .h-stack.gap-4.justify-between .h5:last').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>'); 
                // }
                
            }
            else {
                jQuery(cartPageCartTotalPrice).html(`<div>Subtotal</div><div data-subtotal=""><span aria-hidden="true">${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)}</span><span class="visually-hidden">${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)}</span></div>`);
               //jQuery('.cart-order__recap .h-stack.gap-4.justify-between .h5:last').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            }
        }
    }
 var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          if (jQuery(window).width() < 700) {
          //  jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__footer .totals').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
          else{
           // jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__footer .totals').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }
      var CheckoutClickCart = function () {
        jQuery(checkoutButtonCartPage).click(async function (e) {
          e.preventDefault()
        TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
         await setDateTimeInCart();
        window.location.href = '/checkout';
        });
    }

   var CheckoutClickAjax = function () {
 async function CallGetCodeAjax() {// this is  only for ajax and drawer 
     TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
      await setDateTimeInCart();
     window.location.href = '/checkout'
 }
 jQuery('.drawer-bottom button[name="checkout"]').once('click', CallGetCodeAjax);
}

  jQuery.fn.once = function(a, b) {
   return this.each(function() {
    jQuery(this).off(a).on(a,b);
   });
 };


    var GetCode = function (isUpper) {
        if (priceDiff > 0) {
            jQuery.ajax({
                type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateDiscountCodeMultiCurrencycombined",
                  data: {TierProductsarray:JSON.stringify(TierProducts),priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString(),cartobject:JSON.stringify(globalFieldsCartPage_AC.cartObj) },
                success: function (result) {
                    var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                    if (!isUpper) {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                      	window.location.href = '/checkout?discount=' + DiscountCode;
                    } else {
                        DiscountCodeCookie(DiscountCode);
                        //jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                        window.location.href = '/checkout?discount=' + DiscountCode;
                    }
                },
                error: function (e) { console.log(e.statusText); window.location.href = '/checkout?discount=' + 'NODISCOUNT'; }
            });
        }
        else if (isUpper) {
          window.location.href = '/checkout?discount=' + '';
        }
      else{
       window.location.href = '/checkout?discount=' + '';
      }
    }

    var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
    }

    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;

  	var hide_buttons = null;
  	var HideAdditionalPayments = function() {      
      hide_buttons = setInterval(function() {
        // console.log('buttons and tiered');
        if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
          jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
          clearInterval(hide_buttons);
        }
      }, 500);
    }
  
    var TieredPricingCart = function (cartObject, isUpdate) {
      tempSubtotal = 0;
      $('#data-discounts-main .cart__discounts').hide()
        setCheckOutBtnDisable = true
        makeEnableDisablebtn(true)
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
        TierProducts = [];
        postDataDiscountArrayObject = [];
        orderDiscount =[]
        bulkBuyOnCollection = {};
        qtyDiscountedVariantIds = [];
        nonDiscountedItems = [];

        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);
          // Exlude customer 
           // var customerExludeoption = true;
           // if(itemTiers != undefined) {
           //   customerExludeoption =  globalFields.customerExludeTags(itemTiers.excludeCustomerTags)
           //  }
          if (itemTiers != undefined && itemTiers.status  &&  globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
        
            let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
               if(DiscountAppliedOn){
                if(Location_Tag_s){
                   let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                   let LocationObject = Object.keys(itemTiers.Location_Tag_);
                   if(LocationObject[0] == 'StoreLocation'){
                    let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                    if(StoreLocationcheck && DiscountAppliedOnTag){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                      }else{
                      updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                      }
                   }else{
                   let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                     if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                     }else{
                       updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }
                                                   
                 }else{
                  if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                   var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                  updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                  if (rslt[1]) {
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                 }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
                 }
                 
               }else{
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                }
                 
               }

            
             }
            else {
              
                UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, true, k);
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
          
            if (!isInRange) {
              qtyDiscountedVariantIds.push(`gid://shopify/ProductVariant/${item.variant_id}`);
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
              } else {
                  // NO discount → eligible for subtotal
                  nonDiscountedItems.push(item);
              }
        }

let subtotalTier = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield;

if (
  subtotalTier &&
  subtotalTier.status &&
  nonDiscountedItems.length > 0
) {
  let discountValue = getSubtotalDiscount(subtotalTier, nonDiscountedItems);

  if (discountValue > 0) {
    let tempOrderDiscount = createOrderDiscount(
      subtotalTier.discountTitle || "SUBTOTAL_DISCOUNT",
      qtyDiscountedVariantIds,
      subtotalTier.discount_type,
      discountValue
    );

    orderDiscount.push(tempOrderDiscount);

    updatedTotalPrice -= discountValue;
    priceDiff += discountValue;
  }
}


        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
        setDateTimeInCart()
      	if(priceDiff){
          HideAdditionalPayments();
        }
      	setTimeout(function(){
          clearInterval(hide_buttons);
        }, 5000);
    }
setTimeout(function(){
      clearInterval(hide_buttons);
    }, 10000);



function getSubtotalDiscount(tierObj, items) {
  if (!tierObj || !tierObj.tier_min) return 0;

  let totalQty = 0;
  let subtotal = 0;

  // 👉 calculate both
  items.forEach(item => {
    totalQty += item.quantity;
    subtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
  });

  let discountValue = 0;

  for (let i = 0; i < tierObj.tier_min.length; i++) {
    let min = parseFloat(tierObj.tier_min[i]);
    let max = tierObj.tier_max[i] === "max"
      ? Infinity
      : parseFloat(tierObj.tier_max[i]);

    let tierValue = parseFloat(tierObj.tier_values[i]);

    let isMatch = false;

    // 🔥 THIS IS THE KEY PART
    if (tierObj.DiscountBasedOn === "Range of Quantities") {
      isMatch = totalQty >= min && totalQty <= max;
    } else if (tierObj.DiscountBasedOn === "Range of Amount") {
      isMatch = subtotal >= min && subtotal <= max;
    }

    if (isMatch) {
      if (tierObj.discount_type === "percentage") {
        discountValue = (tierValue / 100) * subtotal;
      } else if (tierObj.discount_type === "fixed") {
        discountValue = tierValue;
      }
      break;
    }
  }

  return discountValue;
}


    var GetTiersFromTiersArray = function (variantId) {
        var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
        if (tierObj[0].tiers == "[]") {
            return undefined;
        }
        else {
            return globalFields.GetTierObject(tierObj[0].tiers[0], variantId);
        }
    }

    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
      let isFound = TierProducts.some(element => {if (element.VarientID === item.variant_id) { return true;}return false;});
        for (i = 0; i < itemTiers.tier_min.length; i++) {
            var allVariantItemQty = 0;
            var tierPrice = parseFloat(itemTiers.tier_values[i]);
            let tempTierProductsobj = {};
            let postDataDiscountObject = {};
            var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
            var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;
                var tempItemArray = [];
                var tempTierArray =[]
                 /*start if condtion*/ 

                if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {

             const isValidStore = (tier) => tier.DiscountAppliedON === 'Both_Store' || tier.DiscountAppliedON === 'Online_Store';

                if (itemTiers.entity_type === 'collections') {
                  if (itemTiers.discount_type == 'bulkBy') {
                     tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (
                      n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && 
                      n.tiers[0].entity_id == itemTiers.entity_id &&
                     isValidStore(n.tiers[0]) &&
                     n.tiers[0].discount_type == 'bulkBy'
                    
                    ); });
                     }else{
                       tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (
                      n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && 
                      n.tiers[0].entity_id == itemTiers.entity_id &&
                     isValidStore(n.tiers[0]) 
                      
                    ); 
                  });
                     }


                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                else {
                  
                    if (itemTiers.discount_type == 'bulkBy') {
                      
                      tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (
                       n.tiers != '[]' &&
                      n.tiers[0].discountCouponTitle == itemTiers.discountCouponTitle &&
                      n.tiers[0].entity_type == "products" &&
                      isValidStore(n.tiers[0]) &&
                      n.tiers[0].discount_type
                      
                    ); });
                    }else{
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
                    }

                                 for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }
              

               
               

            if (condition1 && condition2) {
                 var Vid = `gid://shopify/ProductVariant/${item.variant_id}`;
                var currencyRate = Shopify.currency.rate;
                var qtys = item.quantity;
                var price = Number(item.original_price / 100).toFixed(2);
                discountMsg = itemTiers.discountCouponTitle || discountMsg;
                isNotInRange = false;
                
                if (itemTiers.discount_type == 'percentage') {
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
                     if(!isFound){
                      tempTierProductsobj['Discountvalue'] = originalPriceCut;
                      tempTierProductsobj['DiscountType'] = 'fixed';
                      tempTierProductsobj['VarientID'] = item.variant_id;

                        let resposne = createAmountOffDiscountObject(discountMsg, Vid, currencyRate, originalPriceCut, qtys);
                        postDataDiscountObject = resposne;
                      //  let resposne = createPercentageDiscountObject(discountMsg, tierPrice, Vid);
                      //   postDataDiscountObject = resposne;
                    }  
                }
                else if (itemTiers.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice));
                   if(!isFound){
                      tempTierProductsobj['Discountvalue'] = tierPrice;
                      tempTierProductsobj['DiscountType'] = itemTiers.discount_type;
                      tempTierProductsobj['VarientID'] = item.variant_id;
                       let resposne = createAmountOffDiscountObject(discountMsg, Vid, currencyRate, tierPrice, qtys);
                        postDataDiscountObject = resposne;
                    }
                 }
                else if (itemTiers.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                    if(!isFound){
                      tempTierProductsobj['Discountvalue'] = tierPrice;
                      tempTierProductsobj['DiscountType'] = itemTiers.discount_type;
                      tempTierProductsobj['VarientID'] = item.variant_id;
                        let resposne = createDiscountedPriceDiscountObject(discountMsg,Vid,currencyRate,tierPrice,qtys,price);
                        postDataDiscountObject = resposne;
                    } 
                  }
                      else if (itemTiers.discount_type == 'bulkBy') {

                          let bundleSize = parseInt(minTier);
                          let bundlePrice = parseFloat(tierPrice);

                          let bundleUnitPrice = bundlePrice / bundleSize;

                          if (!bulkBuyOnCollection[itemTiers.entity_id]) {

                              let units = [];
                            //   let tempTierArray = []
                            //    if (itemTiers.entity_type === 'collections') {

                            //     tempTierArray = jQuery.grep(
                            //         globalFieldsCartPage_AC.cartTiersArray,
                            //         function (n) {
                            //             return (
                            //                 n.tiers != '[]' &&
                            //                 n.tiers[0].entity_type == 'collections' &&
                            //                 n.tiers[0].entity_id == itemTiers.entity_id
                            //             );
                            //         }
                            //     );

                            // }else {
                            //       tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (
                            //        n.tiers != '[]' &&
                            //       n.tiers[0].discountCouponTitle == itemTiers.discountCouponTitle &&
                            //       n.tiers[0].entity_type == "products" &&
                            //       n.tiers[0].DiscountAppliedON == 'Both_Store' || n.tiers[0].DiscountAppliedON == 'Online_Store'
                                  
                            //     ); });
                            // }


                              for (let m = 0; m < tempItemArray.length; m++) {

                                  let temp = jQuery.grep(
                                      globalFieldsCartPage_AC.cartObj.items,
                                      function (n) {
                                          return n.variant_id == tempTierArray[m].variant_id;
                                      }
                                  );

                                  if (temp.length) {

                                      let price = temp[0].original_price / 100;

                                      for (let q = 0; q < temp[0].quantity; q++) {

                                          units.push({
                                              variant: temp[0].variant_id,
                                              price: price,
                                              discount: 0
                                          });

                                      }

                                  }

                              }

                              /* index-based bundles */
                              let bundleCount = Math.floor(units.length / bundleSize);
                              let discountedUnits = bundleCount * bundleSize;

                              for (let i = 0; i < discountedUnits; i++) {

                                  let u = units[i];

                                  let newPrice = bundleUnitPrice;

                                  u.discount = u.price - newPrice;

                              }

                              bulkBuyOnCollection[itemTiers.entity_id] = units;
                          }

                          let units = bulkBuyOnCollection[itemTiers.entity_id];

                          let qty = item.quantity;
                          let discountTotal = 0;

                          for (let i = 0; i < units.length; i++) {

                              if (units[i].variant == item.variant_id && units[i].discount > 0) {

                                  discountTotal += units[i].discount;

                                  units[i].discount = 0;

                                  qty--;

                                  if (qty <= 0) break;

                              }

                          }

                          let originalLine = (item.original_price / 100) * item.quantity;

                          let finalLinePrice = originalLine - discountTotal;

                          updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(finalLinePrice);

                          updatedItemPrice = updatedLinePrice / item.quantity;

                          if (!isFound && discountTotal > 0) {

                              tempTierProductsobj['Discountvalue'] = discountTotal;
                              tempTierProductsobj['DiscountType'] = 'FixedAmount';
                              tempTierProductsobj['VarientID'] = item.variant_id;

                              let response = createAmountOffDiscountObject(
                                  discountMsg,
                                  Vid,
                                  currencyRate,
                                  discountTotal / item.quantity,
                                  item.quantity
                              );

                              postDataDiscountObject = response;

                          }
                          if (discountTotal <= 0) {
                            postDataDiscountObject = null
                          }
                      }

                if (updatedItemPrice < 0) { updatedItemPrice = 0; }
                if (itemTiers.discount_type != 'bulkBy') {
                  updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                }
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index);
                  if(!isFound){
                if (postDataDiscountObject != null) {
                        postDataDiscountArrayObject.push(postDataDiscountObject);
                        TierProducts.push(tempTierProductsobj);
                    }
              }
            }
        }
        if (isNotInRange) {
            UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
        }
        return [updatedTotalPrice, isNotInRange];
    }


    function excludeProductsOnTier() {
       let cartItems = globalFieldsSubtotalCartPage_AC.cartObj?.items || [];
        let excludeProducts = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield?.excludeProducts || [];
        let excludeTags = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield?.excludeTags || [];
        let cartTiersArray = Array.isArray(cartItems) && cartItems.length > 0 ? cartItems.map(item => {
            let isExcluded = Array.isArray(excludeProducts) && excludeProducts.some(exclude => exclude.id === item.product_id.toString());
            if (!isExcluded && Array.isArray(excludeTags) ) {
                 isExcluded = globalFieldsSubtotalCartPage_AC.cartTiersArray.some(excludeTag => item.id == excludeTag.item.id && excludeTag.is_exclude);
                }
            return { item: item, is_exclude: isExcluded };
        }) : [];
       return cartTiersArray
  }


    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                CheckoutClickAjax();
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    /*
        var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
        function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
        function sendReplacement(data) {
            this.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    ProcessCartResponse(this._url, this.responseText);
                }
            };
            return send.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });

    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                setTimeout(function () {
                    FetchCartTiers();
                }, 800);
            }
        }
    }

    try{
        var nativeFetch = window.fetch;
        window.fetch = function(...args) {
          if(args[0].includes("/cart/change") || args[0].includes("/cart/add")){
            setTimeout(function () {
              fetch('/cart.js')
              .then(r =>  r.json().then(data => ({status: r.status, body: data})))
              .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
            }, 500);
          }
          return nativeFetch.apply(window, args);
        }
      }
      catch(e){}



        
  function makeEnableDisablebtn(isEnable) {

    if(isEnable){
      // jQuery('.drawer-bottom button[name="checkout"]').prop('disabled', true);
      jQuery(checkoutButtonCartPage).prop('disabled', true);
      jQuery(checkoutButtonCartPage).text('\n                    \n                      Loading...\n                    \n                  '); 
     // jQuery('#cart-notification button[name="checkout"]').prop('disabled', true);
      //jQuery('#cart-notification button[name="checkout"]').text('\n                    \n                      Loading...\n                    \n                  ')
     

    }else{
      setTimeout(() => {
  // console.log("This message appears after 1 second");
  if (!setCheckOutBtnDisable) {
    jQuery(checkoutButtonCartPage).text('\n                    \n                      Checkout\n                    \n                  ')
    //jQuery('#cart-notification button[name="checkout"]').text('\n                    \n                      Checkout\n                    \n                  ')
  
    jQuery(checkoutButtonCartPage).prop('disabled', false);
   // jQuery('#cart-notification button[name="checkout"]').prop('disabled', false);
    
  }
}, 1000);
      
    }

  }

  

      window.addEventListener('load', function() {
        setTimeout(function() {
            // console.log('This will After 2sec run.');
            
            TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
         }, 2000);
     });
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var globalFieldsSubtotalCartPage_AC = new ACDiscountApp.SubCartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();